<lib-app-layout
  [navOptions]="navOptions"
  [menuItems]="menuItems"
  (navClick)="navClick($event)"
  [current]="current"
  [dynamicMargin]="dynamicMargin"
>
  <div class="premium-feature">
    @if(isSysAdmin || !isSalesOps){ @if((firmwareUpdateFeature$ | async)?.navButtonVisible ||
    (notificationCenterFeature$ | async)?.navButtonVisible || (rmsVariationAnalysisFeature$ | async)?.navButtonVisible
    || (sarfiAnalysisFeature$ | async)?.navButtonVisible){
    <div class="premium-feature-large">
      @if ((firmwareUpdateFeature$ | async)?.navButtonVisible) {
      <p-button
        severity="info"
        appEventTracking="header.firmwareUpdate"
        pTooltip="{{ 'global.firmwareUpdate' | translate }}"
        tooltipPosition="bottom"
        [routerLink]="['/admin']"
        data-cy="systems"
        #overlayOriginFirmware="cdkOverlayOrigin"
        cdkOverlayOrigin
      >
        <mat-icon svgIcon="firmware-update"></mat-icon>
      </p-button>
      @defer {
      <app-hint-box
        [hint]="'firmwareUpdate'"
        [overlayOrigin]="overlayOriginFirmware"
        [isOpenedInput]="hintFirmwareIsOpened"
        (closeHint)="hintFirmwareIsOpened = false"
        (openHint)="hintFirmwareIsOpened = true"
      >
        {{ 'hint.firmwareUpdate' | translate }}
      </app-hint-box>
      } } @if ((notificationCenterFeature$ | async)?.navButtonVisible) {
      <p-button
        severity="info"
        appEventTracking="header.notificationCenter"
        pTooltip="{{ 'global.notificationCenter' | translate }}"
        tooltipPosition="bottom"
        [routerLink]="['/notification']"
        data-cy="notification-center"
        #overlayOriginNotification="cdkOverlayOrigin"
        cdkOverlayOrigin
      >
        <mat-icon svgIcon="bell-cog-outline"></mat-icon>
      </p-button>
      @defer {
      <app-hint-box
        [hint]="'notificationCenter'"
        [overlayOrigin]="overlayOriginNotification"
        [isOpenedInput]="hintNotificationIsOpened"
        (closeHint)="hintNotificationIsOpened = false"
        (openHint)="hintNotificationIsOpened = true"
      >
        {{ 'hint.notificationCenter' | translate }}
      </app-hint-box>
      } } @if ((rmsVariationAnalysisFeature$ | async)?.navButtonVisible) {
      <p-button
        severity="info"
        class="left-gap"
        appEventTracking="header.rmsVariationAnalysis"
        pTooltip="{{ 'rmsVariationAnalysis.navigationButtonTooltip' | translate }}"
        tooltipPosition="bottom"
        [routerLink]="['/rms-variation-analysis']"
        [queryParams]="{ type: FleetDisturbanceAnalysisType.RMS }"
        data-cy="rms-analysis-nav-button"
        #overlayOriginVarAnalysis="cdkOverlayOrigin"
        cdkOverlayOrigin
      >
        <mat-icon svgIcon="chart-box-outline"></mat-icon>
        {{ 'rmsVariationAnalysis.navigationButtonTitle' | translate }}
      </p-button>
      @defer {
      <app-hint-box
        [hint]="'rms'"
        [overlayOrigin]="overlayOriginVarAnalysis"
        [isOpenedInput]="hintRmsIsOpened"
        (closeHint)="hintRmsIsOpened = false"
        (openHint)="hintRmsIsOpened = true"
        (openWattsNew)="openReleaseNews()"
      >
        <span [innerHTML]="'hint.rms' | translate"></span>
      </app-hint-box>
      } } @if ((sarfiAnalysisFeature$ | async)?.navButtonVisible) {
      <p-button
        severity="info"
        class="left-gap"
        appEventTracking="header.sarfiAnalysis"
        pTooltip="{{ 'sarfi.navigationButtonTooltip' | translate }}"
        tooltipPosition="bottom"
        [routerLink]="['/rms-variation-analysis']"
        [queryParams]="{ type: FleetDisturbanceAnalysisType.SARFI }"
        data-cy="sarfi-analysis-nav-button"
        cdkOverlayOrigin
      >
        <mat-icon svgIcon="chart-box-outline"></mat-icon>
        {{ 'sarfi.navigationButtonTitle' | translate }}
      </p-button>
      }
    </div>
    <div class="premium-feature-small">
      <p-button
        styleClass="p-button-icon-only"
        [rounded]="true"
        [text]="true"
        class="admin-menu-button"
        (click)="adminMenu.toggle($event)"
        #overlayOriginFirmwareAndNotification="cdkOverlayOrigin"
        cdkOverlayOrigin
      >
        <mat-icon svgIcon="firmware-update"></mat-icon>
      </p-button>
      @defer {
      <app-hint-box
        [hint]="'firmwareAndNotification'"
        [overlayOrigin]="overlayOriginFirmwareAndNotification"
        [isOpenedInput]="hintFirmwareAndNotificationIsOpened"
        (closeHint)="hintFirmwareAndNotificationIsOpened = false"
        (openHint)="hintFirmwareAndNotificationIsOpened = true"
        >{{ 'hint.firmwareAndNotification' | translate }}</app-hint-box
      >
      }
      <p-menu class="admin-menu" #adminMenu [model]="premiumFeatureItemSmall" [popup]="true"> </p-menu>
    </div>
    }}
  </div>
  <ng-template #changeSelection class="help-support">
    @if((changeAccountSelectionFeature$ | async)?.enabled){ @if (showChangeMpSelection) { @if(!smallScreen){
    <div class="current-selection-wrapper">
      @if ((canSelectMp | async) && mpId) {
      <p-button
        data-cy="customer-contact"
        [disabled]="viewerMode$ | async"
        styleClass="p-button-icon-only"
        [text]="true"
        [rounded]="true"
        pTooltip="{{ 'manageCustomerAccount.tooltip.customerInfo' | translate }}"
        tooltipPosition="bottom"
        [severity]="(viewerMode$ | async) ? 'secondary' : 'info'"
        (click)="navigateManageMember('/manage-members/customer', mp.accountId)"
      >
        <mat-icon svgIcon="account-multiple"></mat-icon>
      </p-button>
      } @if (mpId) {
      <div
        data-cy="current-account"
        [ngClass]="mpOptions.length === 1 ? '' : 'display-none'"
        class="current-selection"
        [pTooltip]="headerName$ | async"
        tooltipPosition="bottom"
      >
        {{ headerName$ | async }}
      </div>
      <p-select
        class="select-last-mp"
        [ngClass]="mpOptions.length > 1 ? '' : 'display-none'"
        appendTo="body"
        [options]="mpOptions"
        [(ngModel)]="mpId"
        optionValue="measurementPointId"
        [disabled]="mpOptions.length === 1 || isFleetView"
        (onShow)="lastMpOpen = true"
        (onHide)="lastMpOpen = false"
      >
        <ng-template pTemplate="selectedItem" let-selectedOption>
          <div
            data-cy="current-account"
            class="current-selection"
            [pTooltip]="lastMpOpen ? null : (headerName$ | async)"
            tooltipPosition="bottom"
          >
            {{ headerName$ | async }}
          </div>
        </ng-template>

        <ng-template let-mp pTemplate="item">
          <div data-cy="current-account" class="current-selection" style="width: 100%" (click)="selectMp(mp)">
            {{ mp | headerName : mp.accountName : mp.site : mp.mpName : mp.timezone }}
          </div>
        </ng-template>
      </p-select>
      }
      <p-button
        variant="outlined"
        data-cy="change-mp-button"
        class="change-mp-button"
        (click)="onChangeSelection()"
        appEventTracking="header.changeSelection"
        [disabled]="isFleetView"
      >
        {{ 'header.change-selection' | translate }}
      </p-button>
    </div>
    } @else {
    <div class="change-selection-small">
      <p-button
        styleClass="p-button-icon-only"
        (click)="onChangeSelection()"
        appEventTracking="header.changeSelection"
        [rounded]="true"
        [text]="true"
      >
        <img class="change-selection-icon" src="./assets/images/change-selection-icon.png" />
      </p-button>
    </div>
    } } }
  </ng-template>

  @if(!isSalesOps || (isSysAdmin$ | async)) {
  <app-head-banner class="banner"></app-head-banner>
  }
  <ng-template #helpSupport class="help-support">
    <div class="contacts-menu-wrapper">
      <div class="help">
        <mat-icon svgIcon="help-circle-outline"></mat-icon>
        <strong>{{ 'header.contact-info.help-support' | translate }}</strong>
      </div>
      <div data-cy="welcome-button" class="menu-link menu-link-first" (click)="openWelcomeMessage()">
        <span>
          {{ 'welcome.menu' | translate }}
        </span>
        <mat-icon svgIcon="chevron-right"></mat-icon>
      </div>
      <div data-cy="release-new-button" class="menu-link menu-link-last" (click)="openReleaseNews()">
        <span>
          {{ 'news.whats-new' | translate }}
        </span>
        <mat-icon svgIcon="chevron-right"></mat-icon>
      </div>

      <div class="contact-info">
        <div>
          <strong>{{ 'header.contact-info.contact-powerside' | translate }}:</strong>
        </div>
        <div>
          {{ 'global.email' | translate }}:
          <a href="mailto:support@powerside.com">support&#64;powerside.com</a>
        </div>
        <div>{{ 'global.phone' | translate }}: 1-877-333-8392</div>
      </div>
      <div class="version-info">
        {{ 'global.version' | translate : { version: version } }}
      </div>
    </div>
  </ng-template>

  <ng-template #changeSelectionSmallLabel class="change-selection-small-label">
    @if((changeAccountSelectionFeature$ | async)?.enabled){
    <div class="current-selection-wrapper current-selection-wrapper-small">
      <p-button
        [disabled]="viewerMode$ | async"
        styleClass="p-button-icon-only"
        [text]="true"
        [rounded]="true"
        pTooltip="{{ 'manageCustomerAccount.tooltip.customerInfo' | translate }}"
        tooltipPosition="bottom"
        [severity]="(viewerMode$ | async) ? '' : 'info'"
        (click)="navigateManageMember('/manage-members/customer', mp.accountId)"
      >
        <mat-icon svgIcon="account-multiple"></mat-icon>
      </p-button>
      @if (mpId) {
      <div
        data-cy="current-account"
        [ngClass]="mpOptions.length === 1 ? '' : 'display-none'"
        class="current-selection"
        [pTooltip]="headerName$ | async"
        tooltipPosition="bottom"
      >
        {{ headerName$ | async }}
      </div>
      }
    </div>
    }
  </ng-template>
  @if(possibleHint){
  <div #overlayOriginHint="cdkOverlayOrigin" cdkOverlayOrigin class="hint">
    @if (hintReportIsOpened && ((mobileMenuOpen && smallScreen) || !smallScreen)) {
    <app-hint-box
      #hintBox
      [overlayOrigin]="overlayOriginHint"
      [hint]="'reportWriter'"
      [isOpenedInput]="hintReportIsOpened"
      (closeHint)="hintReportIsOpened = false"
      (openHint)="hintReportIsOpened = true"
    >
      {{ 'hint.reportWriter' | translate }}
    </app-hint-box>
    } @if (hintReportNewIsOpened && ((mobileMenuOpen && smallScreen) || !smallScreen)) {
    <app-hint-box
      #hintBox
      [overlayOrigin]="overlayOriginHint"
      [hint]="'reportWriterNew'"
      [isOpenedInput]="hintReportNewIsOpened"
      (closeHint)="hintReportNewIsOpened = false"
      (openHint)="hintReportNewIsOpened = true"
    >
      {{ 'hint.reportWriterNew' | translate }}
    </app-hint-box>
    }
  </div>
  }
</lib-app-layout>
@if(showChangeSelectionDialog){
<app-change-selection [(showDialog)]="showChangeSelectionDialog"></app-change-selection>
}
<p-dialog
  [header]="'welcome.title' | translate : { firstName: firstName }"
  [(visible)]="showWelcomeDialog"
  [modal]="true"
  [style]="{ width: '950px', maxWidth: '98vw', maxHeight: '98vh' }"
  [dismissableMask]="true"
  [draggable]="false"
  [resizable]="false"
  [closeOnEscape]="true"
  styleClass="front-panel"
>
  <app-welcome-dialog (closed)="showWelcomeDialog = false"></app-welcome-dialog>
</p-dialog>

<app-release-news [(showDialog)]="showReleaseDialog"></app-release-news>
@if (loadingMp) {
<app-loader [loading]="loadingMp"></app-loader>
}
